/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import * as React from 'react';
import { useField } from 'formik';

import { Control, useController } from 'react-hook-form';
import { CmdError } from '@commander-services/gui-components';
import { on } from 'events';
import Error from './Error';
import SearchService from '../../../Services/SearchService';
import useOutsideClick from '../../../hooks/useOutsideClick';
import useKeyPress, { ESCAPE_KEY } from '../../../hooks/useKeyPress';
import { IGroupSelectOptionAction, IGroupSelectOptions, IOption } from '../CmdField';

interface IGroupSelectHookFormProps {
  id: string;
  name: string;
  label: string;
  options: IGroupSelectOptions;
  control: Control<any>;
  placeholder?: string;
  width?: string;
  disabled?: boolean;
  required?: boolean;
  searchPlaceholder?: string;
  onChangeCallback?: (value: any) => void;
  onFocusCallback?: () => void;
  newStyle?: boolean;
  tooltip?: string;
  reload?: boolean;
}

export default function GroupSelectHookForm(props: IGroupSelectHookFormProps) {
  // const [field, meta, handleChange] = useField(props);
  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { invalid, error },
  } = useController({
    name: props.name,
    control: props.control,
    defaultValue: '', // or the default value
  });
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [optionsFromSearch, setOptionsFromSearch] = React.useState<IGroupSelectOptions>(
    props.options
  );
  const [searchString, setSearchString] = React.useState<string>('');
  const [selectedItem, setSelectedItem] = React.useState<string>('');
  const clickOutsideRef: React.RefObject<any> = React.useRef();

  useOutsideClick(clickOutsideRef, () => {
    setIsOpen(false);
  });

  useKeyPress(ESCAPE_KEY, () => {
    setIsOpen(false);
  });

  const selectWidth = props.width ? props.width : 'col-sm-9';

  React.useEffect(() => {
    if (props.reload) {
      setSelectedItem('');
      onChange('');
    }
  }, [props.reload]);

  let errBorder = '';
  if (error) {
    errBorder = 'err-border';
  }

  React.useEffect(() => {
    if (value) {
      setSelectedItem(value);
      // handleChange.setValue(meta.initialValue);
    }
  }, []);

  React.useEffect(() => {
    setOptionsFromSearch(props.options);
  }, [props.options]);

  const handleShowDropdownMenu = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    if (isDropdownMenuOpen) {
      setIsDropdownMenuOpen(false);
    } else {
      setIsDropdownMenuOpen(true);
      // handleChange.setTouched(false);
      // handleChange.setError(false);
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: searchValue } = event.currentTarget;

    setSearchString(searchValue);

    const filteredGroups: IGroupSelectOptions = {};
    if (props.options) {
      Object.keys(props.options).forEach((key: string) => {
        const filtered = props.options[key].filter((option: IOption) =>
          SearchService.removeAccent(option.item.toLowerCase()).includes(
            SearchService.removeAccent(searchValue.toLowerCase())
          )
        );
        if (filtered.length > 0) {
          filteredGroups[key] = filtered;
        }
      });
    }

    if (searchValue) {
      setOptionsFromSearch(filteredGroups);
    } else {
      setOptionsFromSearch(props.options);
    }
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.currentTarget.getAttribute('data-value');
    if (selectedValue) {
      if (selectedItem !== String(selectedValue)) {
        setSelectedItem(selectedValue);
        onChange(selectedValue);
      } else {
        setSelectedItem('');
        onChange('');
      }
      if (props.onChangeCallback) {
        props.onChangeCallback(selectedItem !== String(selectedValue) ? selectedValue : '');
      }
    }
    setIsDropdownMenuOpen(false);
  };

  const handleOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    if (props.onFocusCallback) {
      props.onFocusCallback();
    }
  };

  const options = searchString === '' ? props.options : optionsFromSearch;

  let placeholderText = '';
  if (options) {
    Object.keys(options).forEach((key: string) => {
      const filtered = options[key].filter(
        (option: IOption) => option.value === Number(selectedItem)
      );
      if (filtered.length > 0) {
        placeholderText = filtered[0].item;
      }
    });
  }

  const oldStyleContent: JSX.Element = (
    <div className="group-select-component" ref={clickOutsideRef}>
      <div className="form-group mt-5">
        <div
          id={`${props.id}_e-dropdown-select`}
          className="text-left font-weight-bold col-sm-3 control-label"
        >
          {props.required && (
            <span className="text-danger text-danger required-field-info">* </span>
          )}
          {props.label}
        </div>

        {!props.disabled ? (
          <div
            className={`${selectWidth} dropdown  d-block e-dropdown-select`}
            title={props.tooltip || ''}
          >
            <div className={errBorder} style={{ position: 'relative', flex: '1' }}>
              <input
                // {...field}
                type="hidden"
                id={`hidden-inputForSingleGroupSelectSearch-${props.name}`}
              />
              <input
                onClick={handleShowDropdownMenu}
                type="text"
                className="form-control font-weight-normal fs-2"
                placeholder={props.placeholder}
                value={selectedItem ? placeholderText : props.placeholder ? props.placeholder : ''}
                id={`inputForSingleGroupSelectSearch-${props.name}`}
                readOnly={true}
                onFocus={handleOnFocus}
                data-cy="group-select-placeholder"
              />
              <i
                onClick={handleShowDropdownMenu}
                id={`${props.name}_iconForSingleGroupSelectSearch`}
                className="new-css-icon new-css-icon-dropdown mr-1 fs-5 cursor-pointer"
                style={{ position: 'absolute', right: '3px', top: '7px' }}
              />
            </div>

            {isDropdownMenuOpen && (
              <div
                className="drop-menu-form-active drop-menu-form dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open b-dropdown-list"
                aria-labelledby="dropdownMenu13"
              >
                <div className="pt-1 pb-2 px-2 border-bottom-on">
                  <input
                    type="text"
                    className="form-control font-weight-normal fs-2"
                    id={`${props.name}_selectGroupSearch`}
                    placeholder={props.searchPlaceholder || ''}
                    onChange={handleSearch}
                    value={searchString}
                    autoFocus={true}
                    data-cy={`group-select-search-${props.id}`}
                  />
                </div>
                {optionsFromSearch && Object.keys(optionsFromSearch).length > 0 ? (
                  Object.keys(optionsFromSearch).map((key) => (
                    <div key={key}>
                      <div
                        id={`${props.name}_selectGroupCont`}
                        className="px-2 py-1 d-block text-black font-weight-bold"
                      >
                        <label>
                          <span className="font-weight-bold" style={{ background: 'none' }}>
                            {key}
                          </span>
                        </label>
                        {Object.values(optionsFromSearch[key]).map(
                          (subItem: any, subKey: number) => (
                            <li
                              key={subKey}
                              className={`e-checkbox py-1 d-block text-black font-weight-normal item active `}
                              style={
                                String(selectedItem) === String(subItem.value)
                                  ? {
                                      background: '#D1E9FF',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }
                                  : {
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }
                              }
                            >
                              <div style={{ flex: '1' }}>
                                <label style={{ width: '100%' }}>
                                  <input
                                    type="checkbox"
                                    data-cy={`group-select-${props.id}`}
                                    disabled={props.disabled}
                                    checked={selectedItem === String(subItem.value)}
                                    id={`${props.name}_selectSingleGroupSubCheckbox-${subItem.value}-${subKey}`}
                                    onChange={handleOnChange}
                                    data-value={subItem.value}
                                    style={{ display: 'none' }}
                                  />
                                  <span className="groupSelectSpan pl-4">
                                    <div>{subItem.item}</div>
                                  </span>
                                </label>
                              </div>
                              <div style={{ justifyContent: 'flex-end' }} className="pr-4">
                                {subItem.actions &&
                                  subItem.actions.map(
                                    (action: IGroupSelectOptionAction, index: number) => (
                                      <a
                                        key={`${props.label}-action-${index}`}
                                        href="#"
                                        id={`${props.name}_selectIcon`}
                                        style={
                                          action.title === 'Favorite'
                                            ? {
                                                color: '#b50536',
                                                background: 'none',
                                              }
                                            : { marginRight: '10px' }
                                        }
                                        title={action.title}
                                      >
                                        <i
                                          onClick={action.actionCallback}
                                          data-item-value={subItem.value}
                                          data-item-name={subItem.item}
                                          id={`${props.name}_selectIcon`}
                                          data-cy={`group-select-icon-${index}`}
                                          className={`${action.icon} ${
                                            action.title === 'Download' && 'text-black'
                                          }`}
                                        />
                                      </a>
                                    )
                                  )}
                              </div>
                            </li>
                          )
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div>&nbsp;...</div>
                )}
              </div>
            )}
            {error && error.message && <Error message={error.message} />}
          </div>
        ) : (
          <div className={`${selectWidth} dropdown  d-block e-dropdown-select`}>
            <div className={errBorder} style={{ position: 'relative', flex: '1', color: 'silver' }}>
              <input
                type="text"
                className="form-control font-weight-normal fs-2"
                value={selectedItem ? placeholderText : props.placeholder}
                id={`inputForSingleGroupSelectSearch-${props.name}`}
                readOnly={true}
              />
              <i
                id={`${props.name}_iconForSingleGroupSelectSearch`}
                className="new-css-icons new-css-icon-dropdown mr-1 fs-5 cursor-pointer"
                style={{ position: 'absolute', right: '3px', top: '7px' }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const handleOpen = (
    event:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.MouseEvent<HTMLLabelElement, MouseEvent>
  ) => {
    event.preventDefault();
    setIsOpen(!isOpen);
  };

  const getOptionByValue = (optionValue: string): string | null => {
    let optionName: string | null = null;
    Object.keys(options).forEach((groupName: string) => {
      const option = options[groupName].find(
        (optionItem: IOption) => String(optionItem.value) === String(optionValue)
      );
      if (option) {
        optionName = option.item;
      }
    });

    return optionName;
  };

  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const selectedValue = event.currentTarget.getAttribute('data-value');
    if (selectedValue) {
      if (selectedItem !== String(selectedValue)) {
        setSelectedItem(selectedValue);
        onChange(selectedValue);
      } else {
        setSelectedItem('');
        onChange('');
      }
      if (props.onChangeCallback) {
        props.onChangeCallback(selectedItem !== String(selectedValue) ? selectedValue : '');
      }
    }
    setIsOpen(false);
  };

  const newStyleContent: JSX.Element = (
    <div
      ref={clickOutsideRef}
      className={`group-select-component form-group ${error && 'form-group-error'}`}
    >
      {props.disabled ? (
        <div>
          <label className="d-block form-label">{props.label}</label>
          <div className="d-block">
            <label>{selectedItem ? getOptionByValue(selectedItem) : props.placeholder}</label>
          </div>
        </div>
      ) : (
        <div>
          <label
            className="d-block form-label"
            onClick={handleOpen}
            data-cy={`groupSelectOpen-${props.id}`}
          >
            {props.required && (
              <span className="text-danger text-danger required-field-info">* </span>
            )}
            {props.label}
          </label>
          <div className="d-block">
            <div className={`b-dropdown ${isOpen ? 'open' : ''}`}>
              <div
                id={`selectSearch-${props.id}`}
                data-cy={`selectSearch-${props.id}`}
                className="form-control-labels"
                onClick={handleOpen}
                title={props.tooltip || ''}
              >
                {selectedItem ? getOptionByValue(selectedItem) : props.placeholder}
              </div>
              {isOpen && (
                <div className="b-dropdown__content">
                  <div className="b-dropdown__header">
                    <input
                      type="text"
                      id={`selectSearch-${props.id}`}
                      className="form-control"
                      onChange={handleSearch}
                      value={searchString}
                      placeholder={props.searchPlaceholder}
                      autoFocus={true}
                      data-cy={`group-select-search-${props.id}`}
                    />
                  </div>
                  <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {optionsFromSearch && Object.keys(optionsFromSearch).length > 0 ? (
                      Object.keys(optionsFromSearch).map((groupName: string) => (
                        <div key={groupName}>
                          <div className="b-dropdown__title">{groupName}</div>
                          <ul className="b-dropdown__list simple-list">
                            {Object.values(optionsFromSearch[groupName]).map(
                              (option: IOption, index: number) => (
                                <li key={`${groupName}-${option.item}-${index}`}>
                                  <a
                                    href="#"
                                    className="item"
                                    data-value={option.value}
                                    data-cy={`groupselect-values-${option.value}`}
                                    onClick={handleOnClick}
                                    style={
                                      String(option.value) === String(selectedItem)
                                        ? {
                                            backgroundColor: '#D1E9FF',
                                          }
                                        : {}
                                    }
                                  >
                                    {option.item}
                                  </a>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      ))
                    ) : (
                      <div>&nbsp;...</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {error && error.message && <CmdError message={error.message} />}
          </div>
        </div>
      )}
    </div>
  );

  return props.newStyle ? newStyleContent : oldStyleContent;
}
